export enum CardVariant {
   SmallShadow = "SmallShadow",
   MediumShadow = "MediumShadow",
   StrongShadow = "StrongShadow",
   DashboardCard = "DashboardCard"
}
